import React, { useState, useRef } from 'react';
import './MessageInput.css';

const MessageInput = ({ onSendMessage, disabled }) => {
  const [message, setMessage] = useState('');
  const inputRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmedMessage = message.trim();
    
    if (trimmedMessage && !disabled) {
      onSendMessage(trimmedMessage);
      setMessage(''); // Clear input after sending
      inputRef.current?.focus();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <form className="message-input" onSubmit={handleSubmit}>
      <input
        ref={inputRef}
        type="text"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="ادخل استفسارك هنا ..."
        disabled={disabled}
        className="message-input-field"
      />
      <button 
        type="submit" 
        disabled={!message.trim() || disabled}
        className="message-send-button"
        aria-label="إرسال الرسالة"
      >
        <img 
          src="/assets/send-msg.svg" 
          alt="إرسال" 
          width="24" 
          height="24"
          className="send-icon"
        />
      </button>
    </form>
  );
};

export default MessageInput;
